export const SORTKEYMAP = [
  {
    tableName: "net sales",
    label: "revenue",
  },
  {
    tableName: "total sales",
    label: "revenue",
  },
  {
    tableName: "qty",
    label: "qty",
  },
  {
    tableName: "cogs",
    label: "cogs",
  },
  {
    tableName: "amt $",
    label: "amt_act",
  },
  {
    tableName: "amt %",
    label: "amt_pct",
  },
  {
    tableName: "employee",
    label: "name",
  },
  {
    tableName: "job code",
    label: "job",
  },
  {
    tableName: "plan %",
    label: "plan_pct",
  },
  {
    tableName: "plan $",
    label: "plan_act",
  },
  {
    tableName: "name",
    label: "name",
  },
  {
    tableName: "margin",
    label: "margin",
  },
  {
    tableName: "cost",
    label: "cost",
  },
  {
    tableName: "shift time",
    label: "shift_time",
  },
  {
    tableName: "job",
    label: "job",
  },
  {
    tableName: "clock out",
    label: "clock_out",
  },
  {
    tableName: "clock in",
    label: "clock_in",
  },
  {
    tableName: "sales",
    label: "sales",
  },
];
